import type { MetagameTokenPackageBundle, MetaGamesEventType } from '../../dto/metagames.types';
import type { PackageBundle } from '../app/types';

import { METAGAMES_EVENT_TYPES } from './constants';

export const isMetagameTokenPackageBundles = (
  packageBundles: PackageBundle[],
): packageBundles is MetagameTokenPackageBundle[] => {
  return packageBundles.length > 0 && packageBundles.every((bundle) => bundle.bundleType === 'metagameToken');
};

export const isMetaGamesEventType = (value: unknown): value is MetaGamesEventType =>
  typeof value === 'string' && METAGAMES_EVENT_TYPES.includes(value);
